import { setCookie } from 'lib/web/cookieUtils'
import { DurationSeconds } from 'lib/datetime/durationInSeconds'

export const LEFT_PANE_WIDTH_COOKIE = 'tripPlannerLeftPaneWidth'
export const LEFT_PANE_WIDTH_DEFAULT = 55 // percent

export function setLeftPaneWidthCookie(width: number) {
  setCookie(LEFT_PANE_WIDTH_COOKIE, `${width}`, DurationSeconds.ONE_YEAR, '/', 'Lax')
}
